import React from 'react';

import { styled } from 'styled-components';

import RichTextField from 'components/RichTextField/RichTextField';

interface RichTextFieldProps extends React.ComponentProps<typeof RichTextField> {}

const RichTextFieldWrapper = (props: RichTextFieldProps) => <RichTextField {...props} />;

const ContentBody = styled(RichTextFieldWrapper)`
  color: ${(props) => props.theme.colors.black};

  h1,
  h2,
  h3 {
    font-family: ${(props) => props.theme.fonts.fontFamilySecondary};
    margin-bottom: 1.25rem;
    font-size: 1.5rem;

    @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
      font-size: 1.25rem;
    }
  }

  p {
    font-size: 1.125rem;
    font-weight: 500;
    font-family: ${(props) => props.theme.fonts.default};
    margin-bottom: 0;

    @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
      font-size: 1.125rem;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      font-size: 1rem;
    }
  }

  ul {
    padding-left: 1rem;
    margin: 1rem 0;
  }

  li {
    font-weight: 500;
    font-size: 1rem;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
      margin-bottom: 1rem;
    }
  }

  .bullet-icon {
    font-size: 2rem;
    margin-right: 0.5rem;
    color: ${(props) => props.theme.colors.primaryRed};
  }

  .video-wrapper {
    height: 0;
    padding-bottom: 56.25%;
    position: relative;

    iframe {
      height: 100% !important;
      left: 0;
      position: absolute;
      top: 0;
      width: 100% !important;
    }
  }
`;

export default ContentBody;
